const FactoryController = `Tenant`;

const URLConstants = {
  Authenticate: '/Account/Login',
  Logout: '/Account/Logout',
  ActivateAccount: '/Account/Activate',
  ResendLink: 'Account/Activate/Resend/Link',
  VerifyUserEmail: '/User/UserEmail',
  ResetPassword: '/Account/Update/User/Password ',
  Version: '/v1/Version',
  DeleteFactory: `${FactoryController}`,
  UpdateFactory: `${FactoryController}`,
  AddFactory: `${FactoryController}`,
  GetFactoryById: `${FactoryController}`,
  AllFactorys: `${FactoryController}/GetAll`,
  FactoryList: `${FactoryController}/List`,
  GetAllProcessList: '/Process',
  DeleteProcess: '/Process',
  UpdateProcess: '/Process',
  AddProcess: '/Process',
  GetProcessById: '/Process',
  GetAllProcess: 'Process/GetAllProcess',
  SaveProcessDimensionData: '/Process/SaveDimentionData',
  GetProcessDimensionData: '/Process/GetProcessDimensionData',
  GetAllUsersList: '/User/List',
  DeleteUser: '/User',
  UpdateUser: '/User',
  AddUser: '/User',
  GetUserByTenantId: '/User/TenantId',
  ValidateEmailId: '/User/UserEmail',
  GetAllUsers: '/User/All',
  GetOmsUserList: '/User/List',
  GetUserById: '/User',
  UpdateUserPassword: '/Account/Update/Tenant/ChangePassword',
  TenantList: '/Tenant',
  GetTenantById: '/Tenant',
  AddTenant: '/Tenant',
  UpdateTenant: '/Tenant',
  DeleteTenant: '/Tenant',
  AllTenants: '/Tenant',
  GetUsersByTenantId: '/User/TenantId',
  AllUsers: '/User/All',
  UpdateUserAccountStatus: '/Account/Activate',
  FilterTenantList: '/Tenant/FilterList',
  GetAllPortalList: '/AIMS',
  GetProcessTemplateList: '/ProcessTemplate',
  GetTemplateById: 'ProcessTemplate/GetByTemplateId',
  AddProcessTemplate: '/ProcessTemplate',
  UpdateProcessTemplate: '/ProcessTemplate',
  DeleteProcessTemplate: '/ProcessTemplate',
  AddWeekendHoliday: '/FactorySchedule/AddWeekly',
  AddHoliday: '/FactorySchedule',
  GetFactoryScheduleById: '/FactorySchedule/GetHolidayDetailsById',
  GetAllScheduleList: '/FactorySchedule/AllSchedule',
  DeleteHoliday: '/FactorySchedule',
  AddPortal: '/AIMS',
  UploadHolidaysFile: '/FactorySchedule/ImportCsv',
  ExportFile: '/FactorySchedule/ExportCsv',
  GetAllProductList: '/Product',
  DeleteProduct: '/Product',
  UpdateProduct: '/Product',
  AddProduct: '/Product',
  GetProductById: '/Product/GetById',
  GetAllProduct: 'Product/GetAllProductId',
  GetAllProcessTemplates: '/ProcessTemplate/GetAllTemplates',
  AddProductFile: '/ProductFile',
  AddProductCopyFile: '/ProductFile/SaveCopyFile',
  DeleteProductFile: '/ProductFile',
  ExportProductReport: '/Product/GetProductProcessReport',
  AddTeplar: '/TeplarManagement',
  GetTeplarById: '/TeplarManagement/GetTeplarById',
  GetAllTeplar: '/TeplarManagement',
  GetTeplarPrintFromCSVbyProductId:
    '/TeplarManagement/TeplarPrintFromCSVbyProductId',
  GetTeplarDetailsById: '/TeplarManagement/GetDetailByTeplarId',
  UpdateTeplarDetail: '/TeplarManagement/UpdateTeplarDetail',
  DeleteTeplar: '/TeplarManagement',
  GetAllTrayList: '/Tray',
  DeleteTray: '/Tray',
  UpdateTray: '/Tray',
  AddTray: '/Tray',
  GetTrayById: '/Tray/GetTrayDetailById',
  GetAllTray: 'Tray/GetAllTray',
  GetAllGroupSettingList: '/GroupSetting',
  DeleteGroupSetting: '/GroupSetting',
  UpdateGroupSetting: '/GroupSetting',
  AddGroupSetting: '/GroupSetting',
  GetGroupSettingById: '/GroupSetting',
  GetAllGroupSetting: 'GroupSetting/GetAllGroups',
  UploadTrayFile: '/Tray/ImportCSV',
  GetGroupSettingByName: '/GroupSetting/GetGroupByName',
  GetAllActiveTraysList: '/ActiveTrayManagement',
  GetProcessWiseChart: 'Tray/ProcessWiseChart',
  GetAllOrderTableViewList: '/Dashboard',
  LedBlink: '/Dashboard/BlinkLED',
  HKRDashboardData: '/Dashboard/HKRDashboardData',
  AddGroupCode: '/GroupSetting/AddTrayCode',
  GetAllKishuList: '/KishuMark',
  DeleteKishu: '/KishuMark',
  UpdateKishu: '/KishuMark',
  AddKishu: '/KishuMark',
  GetKishuById: '/KishuMark/GetKishuDetailById',
  GetAllKishu: 'Kishu/GetAllKishu',
  GetKishuMarkByKishu: '/KishuMark/GetKishuMarkByKishu',
  GetAllProcessByUserId: '/Operator/GetAllProcessByUserId',
  CopyProduct: '/Product/AddProductCopy',
  GetOperator: '/Operator',
  CompleteProcess: '/Operator',
  GetTeplarFilesHistory: 'TeplarManagement/GetTeplarFiles',
  RemoveForAbnormality: 'Operator/RemoveAbnormalityProcess',
  GetFilteredTrays: '/Operator/TagFilter',
  AssignTags: '/Operator/AssignTags',
  TagRemoveTrayDetail: '/Operator/TagRemoveTrayDetail',
  RemoveTags: '/Operator/RemoveTags',
  GetTrayFilesHistory: 'Tray/GetTrayCSVImportHistory',
  DownloadTrayFileHistory: 'Tray/GetImportErrorCSV',
  UpdateProcessDueDate: 'ActiveTrayManagement/UpdateProcessDueDate',
  GetColumnList: 'Dashboard/GetColumnList',
  UpdateOperatorProcess: 'Operator/UpdateProcess',
  CheckProcessStatus: 'Operator/CheckProcessStatus',
  DeleteAllHoliday: '/FactorySchedule/DeleteYearHoliday',
  GetAPIVersion: '/Version',
  ValidateProductName: '/Product/ValidateProductName',
  SaveProcessOrder: '/ActiveTrayManagement/SaveProcessOrder',
  GetProductImageById: '/Product/GetProductImageById',
  GetDimensionTableColumn: '/Dimension/GetAllDimention',
  UserLogs: '/logs',
  GetDimensionList: '/Dimension',
  AddDimension: '/Dimension',
  GetByDimensionId: '/Dimension/GetByDimentionId',
  GetDimensionIdByProcess: '/Dimension/GetDimensionByProcessId',
  GetCheckItemTemplateList: '/CheckItem/GetCheckTemplates',
  AddCheckItemTemplate: '/CheckItem',
  UpdateCheckItemTemplate: '/CheckItem',
  DeleteCheckItemTemplate: '/CheckItem',
  GetCheckItemTemplateById: '/CheckItem/GetByCheckTemplateId',
  GetCheckItemListByProcessId: '/CheckItem/GetCheckItemListByProcessId',
  GetAllTagReassignList: '/TagReassign',
  BOMSearchResults: '/BOM',
  MaterialTagAssign: '/BOM/MaterialTagAssign',
  PartsSearch: '/BOM/PartSearch',
  DeleteDimension: '/Dimension',
  PartsSearchColumns: '/BOM',
  TrayTagReassign: '/TagReassign/TagReassignTrays',
  GetTrayReport: '/Tray/GetTrayReport',
  UpdateProcessDueDateWithFilter: 'ActiveTrayManagement/UpdateProcessDueDateWithFilter',
  SaveTeplarOrder: '/Operator/SaveTrayTeplarOrder'
};

export default URLConstants;
